import App from "./AppWrapper.svelte";

const app = new App({ target: document.body });

export default app;
